import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { User } from "lucide-react";

import "../css/sidebar.css";

export default function Sidebar({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const menuItem = [
    { path: "/dashboard", name: "Dashboard" },
    { path: "/pruebas", name: "Pruebas" },
    { path: "/expedientes", name: "Expedientes" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    if (isUserMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isUserMenuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  return (
    <>
      <div style={{ height: "100vh" }} className="d-flex flex-column">
        <div className="d-flex" style={{ flexGrow: 1, overflow: "hidden" }}>
          <aside className="sidebar-wrapper">
            <ul className="sidebar">
              <h2 className="d-flex title-sidebar">BANAS</h2>
              <div className="sidebar-nav">
                {menuItem.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.path}
                      className={`button-container ${location.pathname === item.path ? "active" : ""}`}
                    >
                      {item.icon}
                      <span className="ms-3 button-text">{item.name}</span>
                    </Link>
                  </li>
                ))}
              </div>
            </ul>
            <div className="sidebar-footer">
              <div className="sidebar-user-menu" ref={userMenuRef}>
                {isUserMenuOpen && (
                  <div className="sidebar-user-dropdown">
                    <button
                      type="button"
                      className="sidebar-user-option sidebar-user-option--disabled"
                      disabled
                    >
                      Perfil
                    </button>
                    <button
                      type="button"
                      className="sidebar-user-option"
                      onClick={handleLogout}
                    >
                      Cerrar sesión
                    </button>
                  </div>
                )}
                <button
                  type="button"
                  className={`sidebar-user-btn ${isUserMenuOpen ? "active" : ""}`}
                  onClick={() => setIsUserMenuOpen((open) => !open)}
                  aria-label="Menú de usuario"
                  aria-expanded={isUserMenuOpen}
                >
                  <User size={24} strokeWidth={2} />
                </button>
              </div>
            </div>
          </aside>
          <main className="fondo-main">{children}</main>
        </div>
      </div>
    </>
  );
}
